import TRUNCATE_UNITS from '@/utils/enum/TRUNCATE_UNITS';

const truncate = (entry, length, suffix = '...', unit) => {

  if (entry == undefined) { return entry }

  if (typeof entry === 'string') {
    let entrySplit = entry.split("|");

    if (entrySplit?.length > 1) {
      let truncatedArray = entrySplit.slice(0, length);
      if (entrySplit?.length > length) truncatedArray.push("...");
      return truncatedArray;
    }

    else if (unit === TRUNCATE_UNITS.ARRAY) {
      return [entry];
    }
    
    else if (entry.length > length) {
      return entry.substring(0, length) + suffix;
    }
  }

  if (Array.isArray(entry) && entry.length > length) {
    let truncatedArray = entry.slice(0, length);
    truncatedArray.push("...");
    return truncatedArray;
  }

  return entry;
}

export { truncate };
